import angular from 'angular';
import _ from 'lodash';
import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.salesPerson',
    modules: [
        R,
    ],
})
@Service('SalesPersonStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('users');
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/sales_person.js